import api from './api';

export const reportsApi = {
  getPreset: (preset) => api.get(`/api/reports/presets/${preset}`),
  getPeriod: (startDate, endDate) => api.get(`/api/reports/period?start_date=${startDate}&end_date=${endDate}`),
  getMonth: (year, month) => api.get(`/api/reports/month?year=${year}&month=${month}`),
};
